import {
  Component,
  Input,
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';
import * as moment from 'moment';
import { DatePickerFormat } from 'src/app/core/interfaces/date-picker-format';

@Component({
  selector: 'app-date-input',
  templateUrl: './date-input.component.html',
  styleUrls: ['./date-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: DateInputComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: DateInputComponent,
    },
  ],
})
export class DateInputComponent {
  @Input()
  title = "Select date...";

  @Input()
  isDisabled = false;

  @Input()
  public minDate: DatePickerFormat = { year: 1970, month: 1, day: 1 };
  public maxDate: DatePickerFormat = { year: Number.parseInt(moment().format('y')) + 10, month: 1, day: 1 };

  public value?: number;
  public localValue?: any;

  constructor() {
  }

  ngOnInit(): void {
  }

  onChange = (val: number | undefined) => {
  };

  onTouched = () => { };

  touched = false;

  disabled = false;

  writeValue(val: number) {
    this.value = val;
    if (this.value) {
      this.localValue = this.getFormattedObject(this.value);
    }
  }

  valueChanged(value: any) {
    this.onChange(this.getValueAsTimestamp(value));
  }

  getFormattedString(val: any) {
    if (val) {
      return `${val?.year.toString().padStart(4, '0')}-${val?.month.toString().padStart(2, '0')}-${val?.day.toString().padStart(2, '0')}`;
    }
    return null;
  }

  getValueAsTimestamp(val: any) {
    if (val) {
      return Number.parseInt(moment(this.getFormattedString(val)).format('x'));
    }
    return undefined;
  }


  getFormattedObject(val: number) {
    const splitted = this.getStringValueFromTimestamp(val)?.split('-');

    if (splitted) {
      return {
        year: splitted[0],
        month: splitted[1],
        day: splitted[2],
      };
    }
    return {};
  }

  getStringValueFromTimestamp(date?: number) {
    if (date) {
      let dateString = moment(date).format('YYYY-MM-DD');
      return dateString;
    }
    return null;
  }


  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
